import { decodeEntities } from "@wordpress/html-entities";
import noImage from "../../assets/img/noImage.png";
import classes from "../../scss/Posts.module.scss";
import { Link } from "react-router-dom";

export default function Preview({ post, inView, viewRef, index }) {
  return (
    <div ref={inView ? viewRef : null} className={classes.post__wrapper}>
      <div className={classes.post__number}>{index}</div>
      <div className={classes.post__body}>
        <div className={classes.post__text}>
          <h2 className={classes.post__title}>
            <Link to={post.slug}>{post.title.rendered}</Link>
          </h2>
          <p className={classes.post__date}>
            <span>
              {new Date(post.date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </span>
            <span>{post?._embedded["wp:term"][1][0]?.name || "Agilistry"}</span>
          </p>
          <p className={classes.post__description}>
            {decodeEntities(
              post.custom_fields.shortDescription &&
                post.custom_fields?.shortDescription[0]
            )}
          </p>
        </div>
        <div className={classes.post__image}>
          <img
            width={post.img_url.width}
            height={post.img_url.height}
            src={post.img_url.large || noImage}
            alt={post.title.rendered}
          />
        </div>
      </div>
    </div>
  );
}
